module.exports = __webpack_public_path__ + "img/login-banner.073c9ba4.jpg";